import { put } from '../../api';

export const delExclusaoDados = (data) => {
  return put('/api/indicadores/exclusao/dados', data);
};
